export default __webpack_public_path__ + "ce98685cef9a8b85aca4e5b9802aab5b.png";